// extracted by mini-css-extract-plugin
module.exports = {"titleFav":"Favourites_titleFav__1J1Qv","Fav":"Favourites_Fav__EdUp7"};